/**
 * Pure filter constants for the "minimum item count" filter on the
 * Customer Pricelists list. Same split rationale as
 * `inventory-filters.ts`'s `LOT_EXPIRY_BUCKETS` — kept out of the page
 * component and out of `@/components/ui` since only this module uses it.
 */

export const ITEM_COUNT_BUCKETS: { value: number | null; label: string }[] = [
  { value: null, label: 'Any size' },
  { value: 5, label: '5+' },
  { value: 10, label: '10+' },
  { value: 25, label: '25+' },
  { value: 50, label: '50+' },
]
